import RestService from "./rest.service";

class competencyMaster {
  getListCompetencyMaster(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      if (cycle_id !== undefined && cycle_id !== null && cycle_id !== "") {
        RestService.gets(`app/admin/kpi/competency/category?cycle_id=${cycle_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.gets(`app/admin/kpi/competency/category`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }

  createCompetencyMaster(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/competency/category/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEditCompetencyMaster(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/category/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editCompetencyMaster(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/competency/category/${serial}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteCompetencyMaster(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/competency/category/${id}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getListCompetencySubGroup(serial,cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      if (cycle_id !== undefined && cycle_id !== null && cycle_id !== "") {
        RestService.gets(`app/admin/kpi/competency/category/${serial}/subcategory?cycle_id=${cycle_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.gets(`app/admin/kpi/competency/category/${serial}/subcategory`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }

  createCompetencySubGroup(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/competency/subcategory/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getEditCompetencySubGroup(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/subcategory/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editCompetencySubGroup(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/competency/subcategory/${serial}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteCompetencySubGroup(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/competency/category/${id}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listCompetencyItemByCategory(serial,cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      if (cycle_id !== undefined && cycle_id !== null && cycle_id !== "") {
        RestService.gets(`app/admin/kpi/competency/category/${serial}/master?cycle_id=${cycle_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.gets(`app/admin/kpi/competency/category/${serial}/master`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }

  listCompetencyItemBySubCategory(serial,cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      if (cycle_id !== undefined && cycle_id !== null && cycle_id !== "") {
        RestService.gets(`app/admin/kpi/competency/subcategory/${serial}/master?cycle_id=${cycle_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.gets(`app/admin/kpi/competency/subcategory/${serial}/master`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    });
  }

  getEditCompetencyItem(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/master/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getAddCompetencyItem(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/competency/master/${serial}/add`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getRatingScale(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/kpi/competency/dropdown/scale/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  createCompetencyItem(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/competency/master/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editCompetencyItem(serial, data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/competency/master/${serial}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  deleteCompetencyItem(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/competency/master/${id}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  nextCompetencyItem(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/competency/master/next`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  clearAllCompetencyItem(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/competency/master/${id}/clear`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new competencyMaster();
